import React, { useEffect } from 'react';
import PropTypes from "prop-types";
import {addClass, removeClass} from 'utils';
import { withRouter } from 'react-router';
import Link from 'components/Link';
import { helpCenterFlag } from 'config/index';
import Search from 'components/HelpCenter/Header/Search';
import style from './style.scss';//NOSONAR

let sourceApp = false;
const Header = (props) => {
    useEffect(() => {
        if(!helpCenterFlag && typeof window !== 'undefined'){
            props.history.replace('/Sistema/busquedavacia');
            return false;
        }

        addClass(document.body, 'help-center-body');

        return function cleanup(){
            removeClass(document.body, 'help-center-body');
        }
    }, []);

    if(typeof window !== 'undefined' && window.location.href.includes('?source=app')){
        sourceApp = true;
    }

    let title = `Centro de Ayuda ${(sourceApp ? 'Jumbo' : '')}`

    return <header className='help-header'>
        <div className='help-header-wrapper'>
            {!sourceApp && <Link to="/" className="help-header-logo-link jumbo-icon-logo" aria-label="Jumbo Chile" />}
            {!sourceApp && <Link to="/" className="help-header-text-link" aria-label="Jumbo Chile"> Ir a Jumbo.cl</Link>}
            <div className="help-header-container">
                <Link to="/centro-ayuda" className={'help-center-title ' + (sourceApp ? 'active-source' : '')}>
                    <h1 className="help-title">{title}</h1>
                </Link>
                <Search />
            </div>
        </div>
    </header>;
};

Header.propTypes = {
    history: PropTypes.bool,
};

export default withRouter(Header);
